import { Chart, LineController, LineElement, PointElement, CategoryScale, LinearScale } from 'chart.js';

Chart.register(
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale
);

export const chartPredictions = () => {
    const items = document.querySelectorAll('.market-bet-games-card--chart canvas');

    if (!items.length) return false;

    items.forEach(item => {
        if (item.classList.contains('done')) return false;
        const ctx = item.getContext('2d');
        const dataChart = item.getAttribute('data-chart').split(', ');

        let backgroundColor = '';
        let borderColor = '';

        if (item.dataset.color) {
            backgroundColor = ctx.createLinearGradient(0, 0, 0, 100);
            backgroundColor.addColorStop(0, item.dataset.color+'66');
            backgroundColor.addColorStop(0.3, item.dataset.color+'00');
            borderColor = item.dataset.color;
        }
        if (item.classList.contains('c-green')) {
            backgroundColor = ctx.createLinearGradient(0, 0, 0, 100);
            backgroundColor.addColorStop(0, 'rgba(0, 159, 77, 0.4)');
            backgroundColor.addColorStop(0.3, 'rgba(0, 159, 77, 0)');
            borderColor = 'rgb(0, 159, 77)';
        }
        if (item.classList.contains('c-red')) {
            backgroundColor = ctx.createLinearGradient(0, 0, 0, 100);
            backgroundColor.addColorStop(0, 'rgba(171, 4, 13, 0)');
            backgroundColor.addColorStop(0.4, 'rgba(171, 4, 13, 0.4)');
            borderColor = 'rgb(171, 4, 13)';
        }

        const data = {
            labels: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            datasets: [{
                borderColor,
                borderWidth: 2,
                data: dataChart,
                fill: true,
                pointRadius: 0,
                backgroundColor,
            }]
        };
        const options = {
            scales: {
                x: {
                    display: false,
                },
                y: {
                    min: 0,   // нижняя граница
                    max: 100,  // верхняя граница
                    display: false,
                }
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: false
                }
            },
            elements: {
                line: {
                    borderJoinStyle: 'round'
                }
            },
            datasets: {
                line: {
                    fill: 'origin' // заставляет заливать вниз к оси X
                }
            },
            responsive: true,
            maintainAspectRatio: false
        };
        const myChart = new Chart(ctx, {type: 'line', data, options});
        item.classList.add('done');
    });
};
